<!--
https://bootstrap-vue.org/docs/components/calendar
-->

<template>
    <!--
    <div style="text-align:center"><iframe width="240" height="480" frameborder="0" scrolling="no" src="https://calendario.online/widget/?width=215&cor_barra=4b4389&cor_titulo=ffffff"></iframe></div>
    -->
    <div>
        <b-calendar :hide-header="true" :locale="locale" width="280px" v-bind="labels || {}"></b-calendar>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'componentExternalLinks',
    data: function() {
        return {
            locale: 'pt-BR',
            labels: {                
                labelPrevDecade: 'Década Anterior',
                labelPrevYear: 'Ano Anterior',
                labelPrevMonth: 'Mês Anterior',
                labelCurrentMonth: 'Mês Atual',
                labelNextMonth: 'Próximo Mês',
                labelNextYear: 'Próximo Ano',
                labelNextDecade: 'Próxima Década',
                labelToday: 'Hoje',
                labelSelected: 'Data Selecionada',
                labelNoDateSelected: '-',
                labelCalendar: 'Calendário',
                labelNav: 'Navegação',
                labelHelp: ''
            }
        }
    }
}
</script>